import { IApi } from './api-types';
import { API_BASE_URL } from './env';


class Api implements IApi {

    apiBaseUrl;

    constructor() {
        this.apiBaseUrl = API_BASE_URL;
    }

    async request(url: string, method: string = 'GET', body: any = null, isAuthorized: boolean = true) {
        const options: any = {
            method,
        };
        const headers: any = {
            'Content-Type': 'application/json',
        };
        let sessionId;

        if (isAuthorized) {
            const loginState = localStorage.getItem('warchest');

            if (loginState) {
                const parsedLoginState = JSON.parse(loginState);
                sessionId = parsedLoginState.loginState.sessionId;
                headers.Authorization = `Bearer ${sessionId}`;
            }
        }

        options.headers = headers;

        if (body && typeof body === 'object') {
            options.body = JSON.stringify(body);
        }

        const response = await fetch(`${this.apiBaseUrl}${url}`, options);

        return response;
    }

}

export default new Api();
